/**
 * Phase 18.16-B Batch 3 — /documenten PageBanner wrapper.
 *
 * Lives as `topSection` of the /documenten CmsPageRenderer route. The
 * legacy "hero" block on the same slug is hidden via
 * `hideBlockTypes={["hero"]}` in App.js and marked "Vervangen" in the
 * Backoffice.
 */
import React from "react";
import { FileText } from "lucide-react";
import useInfoPageCms from "../hooks/useInfoPageCms";
import { ToolPageBanner } from "./ToolPageCms";

const FALLBACK = {
  page_banner: {
    eyebrow: "Documenten",
    title: "Alle zending-documenten",
    highlight: "op één plek",
    subtitle:
      "Download voorbeelden, leeg-templates en checklists voor voertuigen, gebruikte goederen en gevaarlijke goederen. Onvolledige documentatie = geen verzending.",
    badges: [
      { icon: "receipt",  label: "Voorbeelden + templates" },
      { icon: "shield",   label: "Geactualiseerd" },
      { icon: "support",  label: "Hulp nodig? Mail ons" },
    ],
  },
  intro: {},
  cta_band: {},
};

export default function DocumentenPageBanner() {
  const { data } = useInfoPageCms("documenten", FALLBACK);
  return (
    <ToolPageBanner
      banner={data?.page_banner || FALLBACK.page_banner}
      image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      imageAlt="Documenthub — alle zending-documenten op één plek"
      eyebrowIcon={FileText}
      testid="documenten-banner"
    />
  );
}
